import classNames from 'classnames';
import * as React from 'react';

import css from './PurchaseFormErrorMessage.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const PurchaseFormErrorMessage = ({ className, children }: Props) => {
  const classes = classNames(css.PurchaseFormErrorMessage, className);

  return <div className={classes}>{children}</div>;
};

export default PurchaseFormErrorMessage;
